<p>document-details works!</p>
